/**
 * dojo-theme.ts — 灯下道场设计基调共享常量
 * 绿炭毡底 + 暖金灯 + 米色决策牌卡;翡翠 = 主行动,暖金 = 奖励。
 */

/** 展示字体:大数字 / 标题( condensed 工业感 ) */
export const DISPLAY_FONT =
  "font-['Avenir_Next_Condensed','DIN_Alternate',Futura,'PingFang_SC',sans-serif]";

/** 道场统一出场缓动 */
export const EASE_OUT: [number, number, number, number] = [0.16, 1, 0.3, 1];
